import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import BaladiyaUpdate from "./BaladiyaUpdate/BaladiyaUpdate";
import BaladiyaRenewal from "./BaladiyaRenewal/BaladiyaRenewal";
import BaladiyaAppliedList from "./BaladiyaAppliedList/BaladiyaAppliedList";
import { useLocation } from "react-router-dom";

export default function Baladiya() {
  const location = useLocation();

  //screen Title Show fun
  const dispatch = useDispatch();
  const title = [{ label: "BALADIYA", link: "/dashboard/Baladiya" }];
  useEffect(() => {
    dispatch(setBreadCrumb(title));

    if (location.state == null) {
    } else {
      setIndex(1);
    }
  }, []);

  //tab index
  const [index, setIndex] = useState(0);
  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            onClick={() => handleIndex(0)}
            className={`p-2 m-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            BALADIYA UPDATE
          </button>
          <button
            onClick={() => handleIndex(1)}
            className={`p-2  m-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            BALADIYA APPLIED LIST
          </button>
          <button
            onClick={() => handleIndex(2)}
            className={`p-2 h-10  m-2  text-black uppercase text-xs mr-4 rounded-md  ${index == 2 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            BALADIYA RENEWAL
          </button>
        </div>
        {index === 0 ? (
          <BaladiyaUpdate setIndex={setIndex} />
        ) : index === 1 ? (
          <BaladiyaAppliedList />
        ) : index === 2 ? (
          <BaladiyaRenewal setIndex={setIndex} />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
